// Realm import removed - service deprecated
import { createThirdwebClient } from 'thirdweb'
import { inAppWallet } from 'thirdweb/wallets'
import CompositeImageCanvasRenderer from 'tools/CompositeImageCanvasRenderer/CompositeImageCanvasRenderer'
import OnPointer from 'lib/OnPointer'
import onResize from 'lib/onResize'
import { controlledEvent } from 'lib/support'
import constants from './constants'

/**
 * The `thread` hosts key application functional content that can be
 * pulled in and used across the application. It's aim is to provide
 * important means of reducing repetion or allowing the reuse or access
 * of complex functionality (see: FBO's)
 */

/** @type {HTMLElement} */
export const ROOT = document.getElementById('root')

/**
 * The URL initialized search params (query strings, used for checking against init)
 */
export const urlSearchParams = new URLSearchParams(window.location.search)

// Disable pinch zooming (as we handle this in app for the city)
document.addEventListener('gesturestart', e => e.preventDefault())
document.addEventListener('gesturechange', e => e.preventDefault())
document.addEventListener('gestureend', e => e.preventDefault())

// Prevent ctrl/meta key & track pad zoom (which also mimics ctrl key zoom)
// We do this because we handle zooming within the app
document.addEventListener(
  'wheel',
  e => {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  },
  controlledEvent
)

const onResized = () => {
  ROOT.style.setProperty('--screen-width', `${onResize.width}px`)
  ROOT.style.setProperty('--screen-height', `${window.innerHeight}px`)
}

onResize.on(onResized, 0)
onResize.handleResize()

/**
 * Manually trigger a resize a short time after init to capture
 * devices that add extraneous UI. Such as iOS's feature that
 * shows a bar at the top of the page when the user has opened
 * the site from a link shared with them via text message
 */
setTimeout(() => {
  onResize.handleResize()
}, 1000)

// Whether is staging
export const isStaging =
  location.origin.indexOf('staging') > -1 ||
  location.origin.indexOf('ngrok') > -1 ||
  location.origin.indexOf('localhost') > -1

// Whether is local host
export const isLocalHost = location.origin.indexOf('localhost') > -1

// Whether is debug
export const isDebug = location.search.includes('ppdebug')

// Realm deprecated - no longer used

// Replace Paper SDK initialization with Thirdweb client
export const thirdwebClient = createThirdwebClient({
  clientId: constants.THIRDWEB_CLIENT_ID
  // Add any other necessary configuration options
})

// Added wallets configuration for Thirdweb
export const wallets = [
  inAppWallet({
    providers: ['email', 'facebook', 'apple', 'google', 'phone', 'passkey']
  })
]

// The avatar base canvas renderer
export const compositeImageCanvasRenderer = new CompositeImageCanvasRenderer()

// User prefers dark mode
export const prefersDarkMode = window.matchMedia(
  '(prefers-color-scheme: dark)'
).matches

/**
 * Check if is a large screen
 *
 * @returns {boolean} true if large screen
 */
export const checkIfLargeScreen = () =>
  onResize.width > constants.BREAKPOINT_LARGE_SCREEN

/**
 * The `thread` contains information that can be shared across
 * the application thread. Particularly the `onResize` mechanism
 * and holding the WebGLApp context
 */
export default {
  now: Date.now(),
  onResize,
  onPointer: new OnPointer(document.body),
  devicePixelRatio
}
